import { render, staticRenderFns } from "./Redpacket.vue?vue&type=template&id=0cf37c3a&"
import script from "./Redpacket.vue?vue&type=script&lang=js&"
export * from "./Redpacket.vue?vue&type=script&lang=js&"
import style0 from "./Redpacket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports